import Web3 from 'web3'

class WalletState {
  wallet = {
    chainId: null,
    account: null,
    lang: 'Ch',
    hasProvider: false,
  }

  config = {
    Pool: '0xA2433EEe239072Fa600e6Ae054FBDB753218231F',
  }

  listeners = []
  subscribed = false

  constructor() {
    this.init()
  }

  init() {
    this.subscribeWeb3()
    this.getConfig()
    this.syncWallet()
  }

  getProvider() {
    const okxProvider = window.okxwallet && window.okxwallet.ethereum
    if (okxProvider) {
      return okxProvider
    }

    const ethereum = window.ethereum
    if (ethereum && Array.isArray(ethereum.providers) && ethereum.providers.length) {
      const providers = ethereum.providers.filter(Boolean)
      return (
        providers.find((provider) => provider && (provider.isOkxWallet || provider.isOKExWallet || provider.isOKXWallet)) ||
        providers.find((provider) => provider && provider.isMetaMask) ||
        providers.find((provider) => provider && !provider.isTronLink) ||
        providers[0]
      )
    }

    return ethereum || Web3.givenProvider || null
  }

  async resolveChainId(provider, web3) {
    try {
      if (provider && provider.request) {
        const chainIdHex = await provider.request({ method: 'eth_chainId' })
        if (chainIdHex) {
          return parseInt(chainIdHex, 16)
        }
      }
    } catch (error) {}

    try {
      return await web3.eth.getChainId()
    } catch (error) {
      return null
    }
  }

  subscribeWeb3() {
    const provider = this.getProvider()
    if (this.subscribed || !provider || !provider.on) {
      return
    }

    this.subscribed = true
    provider.on('accountsChanged', () => {
      this.syncWallet()
    })
    provider.on('chainChanged', () => {
      this.syncWallet()
      this.getConfig()
    })
  }

  async getConfig() {
    const storage = window.localStorage
    if (storage && storage.language) {
      this.wallet.lang = storage.language
    }
    this.notifyAll()
  }

  async syncWallet() {
    const provider = this.getProvider()
    this.wallet.hasProvider = !!provider
    if (!provider) {
      this.wallet.chainId = null
      this.wallet.account = null
      this.notifyAll()
      return
    }

    Web3.givenProvider = provider
    const web3 = new Web3(provider)
    this.wallet.chainId = await this.resolveChainId(provider, web3)

    try {
      const accounts = await provider.request({ method: 'eth_accounts' })
      this.wallet.account = accounts && accounts.length ? accounts[0] : null
    } catch (error) {
      this.wallet.account = null
    }

    this.notifyAll()
  }

  async connectWallet() {
    const provider = this.getProvider()
    this.wallet.hasProvider = !!provider
    if (!provider) {
      this.notifyAll()
      throw new Error('未检测到钱包，请先安装 OKX Wallet 或 MetaMask。')
    }

    Web3.givenProvider = provider
    const web3 = new Web3(provider)
    const accounts = await provider.request({ method: 'eth_requestAccounts' })
    this.wallet.account = accounts && accounts.length ? accounts[0] : null
    this.wallet.chainId = await this.resolveChainId(provider, web3)
    this.notifyAll()
    return this.wallet.account
  }

  async connetWallet() {
    return this.connectWallet()
  }

  onStateChanged(cb) {
    this.listeners.push(cb)
    cb({ ...this.wallet })
  }

  removeListener(cb) {
    this.listeners = this.listeners.filter((item) => item !== cb)
  }

  notifyAll() {
    const payload = { ...this.wallet }
    this.listeners.forEach((cb) => cb(payload))
  }
}

export const CHAIN_ID = 56
export const CHAIN_SYMBOL = 'BNB'
export const CHAIN_ERROR_TIP = '请连接币安主网钱包使用'
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'
export const MAX_INT = '115792089237316195423570985008687907853269984665640564039457584007913129639935'

export default new WalletState()
